/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of files (patients) to display or load files */


(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('consultimagelist', {
      restrict: 'E',
      bindings: {
        consultid: '<?'
      },
      template: `
      <div ng-show="vm.images && vm.images.length > 0"  data-hook="consultimagelist-component">
        <h4>Bilder &amp; Videos</h4>
        <div class="row">
          <div class="col-xs-12 col-md-3" ng-repeat="img in vm.images">
            <img class="img-responsive" ng-src="/routes/files/filereader/{{img.fileid}}" ng-if="vm.isimg(img.mimetype)" data-hook="consultimage" data-filename="{{img.filename}}" data-consult-medium-index="{{$index}}">
            <video controls class="img-responsive" ng-src="{{img.fileid | trustUrl}}"  ng-if="vm.isvideo(img.mimetype)" data-hook="consultvideo" data-filename="{{img.filename}}" data-consult-medium-index="{{$index}}"></video>
            <video controls class="img-responsive" ng-src="/routes/files/filereader/{{img.fileid}}"  ng-if="vm.isvideo(img.mimetype)"></video>
            <br>
            <span ng-show="vm.isimg(img.mimetype)">
                <input type="checkbox" ng-model="img.include" ng-change="vm.saveFile(img)" data-hook="includeconsultimg-{{$index}}" data-label-for="{{img.filename}}">&nbsp;in Befund inkludieren
            </span>
            <span ng-show="vm.isvideo(img.mimetype)"><input type="checkbox" disabled ng-model="img.include">&nbsp;in Befund inkludieren </span>
            <input type="text" ng-model="img.label"  data-hook="includeconsultimglabel-{{$index}}"
                   ng-blur="vm.saveFile(img)"
                   class="form-control" placeholder="Bildunterschrift ..."><br>
          </div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'File', 'FileHelper', 'vertxEventBusService', '$window',
        function ($log, $http, Rlog, File, FileHelper, vertxEventBusService, $window) {
          let vm = this;
          vm.editFile = FileHelper.editFile;
          vm.removeFile = removeFile;
          vm.saveFile = saveFile;
          vm.getTags = getTags;
          vm.isimg = isimg;
          vm.isvideo = isvideo;

          vm.$onInit = function () {
            if (angular.isDefined(vm.consultid)) {
              // let query = {consultid: vm.consultid, type: 'Bild/Foto'};
              // TODO: fix the query / issue
              let query = {consultid: vm.consultid, type: {$ne: 'Datei'}, sharetype: {$ne: 'generic'}};

              File.$search(query).$then(function (files) {
                vm.images = files;
              });
            }
          };

          // vm.consultid might be late propagating, get files on first change
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              // if (angular.isDefined(changes.consultid.currentValue)) {
              vm.consultid = changes.consultid.currentValue;
              if (angular.isDefined(vm.consultid)) {
                // File.$search({consultid: vm.consultid, type: 'Bild/Foto'}).$then(function (files) {
                // TODO: fix the query / issue
                File.$search({
                  consultid: vm.consultid,
                  type: {$ne: 'Datei'},
                  sharetype: {$ne: 'generic'}
                }).$then(function (files) {
                  vm.images = files;
                }, function (err) {
                  $log.error('image file lookup failed for consultid id: ', vm.consultid, err);
                  Rlog.error('file', 'consultimagelist', 'image file lookup failed', {consultid: vm.consultid});
                });
              }
            }
          };

          function isimg(mt) {
            return mt.indexOf('image') >= 0;
          }

          function isvideo(mt) {
            return mt.indexOf('video') >= 0;
          }

          function saveFile(file) {
            if (file.$hasPendingActions()) {
              file.$cancel();
              $log.debug('cancelled file pending actions in consultimagelist');
            }
            file.$save().$then(function () {
              vm.saved = true;
            }, function (err) {
              vm.saved = false;
              $log.error('saving of consult failed: ', err);
              Rlog.error('vcutils.consult', 'consulteditor', 'Saving of consult failed: ', {
                consultid: file._id
              });
            });
          }


          function removeFile(file) {
            file.active = false;
            file.$save();
          }

          function getTags(val) {
            $log.debug('debug - getTags called!');
            let myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
            let match = [
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$unwind: '$flattags'},
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$group: {_id: '$flattags', total: {$sum: 1}}}];

            return $http.post('/routes/files/aggregate', match).then(function (response) {

              let tags = [];
              // $log.debug('tags data received: ', response);
              for (let i = 0; i < response.data.length; i++) {
                tags.push({text: response.data[i]._id});
              }
              $log.debug('debug - tags: ', tags);
              return tags;
            });
          }

          const filesCreateHandler = function (message) {
            $log.debug('debug: file update received: ', message);
            if (angular.isDefined(vm.images)) {
              vm.images.$refresh().$then(function () {
                $log.debug('dms:file:consultimagelist refreshed files');
              }, function (error) {
                $log.error('dms:file:consultimagelist refresh files failed: ', error);
              });
            }
          };

          const filesUpdateHandler = function (message) {
            $log.debug('debug: file update received: ', message);
            let messages = message.split(':');

            // only refresh list if change was NOT triggered by this browser
            if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && angular.isDefined(vm.exam) && vm.exam._id === messages[0]) {
              if (angular.isDefined(vm.images)) {
                vm.images.$refresh().$then(function () {
                  $log.debug('dms:file:consultimagelist refreshed files');
                }, function (error) {
                  $log.debug('dms:file:consultimagelist refresh files failed: ', error);
                });
                $log.debug('(consultimagelist) refreshed images');
              }
            } else {
              $log.debug(' ((consultimagelist)) ignored images change');
            }
          };


          vertxEventBusService.on('files.create', {}, filesCreateHandler);

          vertxEventBusService.on('files.update', {}, filesUpdateHandler);


          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('files.create', {}, filesCreateHandler);
            vertxEventBusService.unregisterHandler('files.update', {}, filesUpdateHandler);
          };


          vm.helpunlink = `Wenn Sie die Dateizuordnung aufheben, wird die Datei wieder in die 
            Scan- bzw. Dateizuordnungliste eingereiht und kann erneut zugeordnet werden. 
            W&auml;hlen Sie diese Option zum Beispiel dann, wenn Sie eine Datei der falschen Person zugeordnet haben.`;

        }] // controller
    }); // component

  // klammerfriedhof
}());
